/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
// material-ui core components
import { List, ListItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";

import styles from "assets/jss/material-kit-react/components/footerStyle.js";
import { Row, Col } from "antd";

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  const { whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  
  return (
    <footer className={footerClasses}>
      <div className={classes.container}>
        <div className={classes.left}>
        <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>  
                <Row style={{padding:15}}>
                  <Col style={{marginRight:10}}>
                  CONTACT PERSON:
                  </Col>
                  <Col>
                    <span style={{marginRight:10}}>{props.setting.no_hp1}</span><span>{props.setting.no_hp2}</span>
                  </Col>
                </Row>                                          
            </ListItem>
          </List>
          
        </div>
        <div className={classes.right}>
          &copy; {1900 + new Date().getYear()}{' '}
          UNIVERSITAS SUMATERA UTARA
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  whiteFont: PropTypes.bool
};
